import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { auth } from "../firebase/firebaseconfig";
import { useNavigate } from "react-router-dom";
import { useGlobal } from '../App';
import { getWishlist, removeFromWishlist } from "../GlobalStates/WishlistService";

const slugify = (str) =>
  str
    ?.toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");

export default function Wishlist() {
  const navigate = useNavigate();
  const { products } = useGlobal();
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = auth.currentUser;

  const buildWishlistItems = useCallback((wishlistEntries) => {
    return (wishlistEntries || [])
      .map((entry) => {
        const product = products.find((p) => p.id === entry.productId);
        if (!product) return null;

        return {
          productId: entry.productId,
          name: product.name,
          category: product.category || entry.category || "",
          imageUrl: product.imageUrl || product.image || "",
          price: entry.price ?? product.price ?? 0,
        };
      })
      .filter((item) => item !== null);
  }, [products]);

  useEffect(() => {
  console.log("Wishlist updated:", wishlist);
      }, [wishlist]);

  useEffect(() => {
    let isMounted = true;

    if (!user) {
      navigate("/login");
      return;
    }

    const loadWishlist = async () => {
      try {
        const wishlistEntries = await getWishlist(user);
        if (isMounted) {
          setWishlist(buildWishlistItems(wishlistEntries));
        }
      } catch (error) {
        console.error("Error loading wishlist:", error);
        if (isMounted) {
          setWishlist([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadWishlist();

    return () => {
      isMounted = false;
    };
  }, [user, navigate, buildWishlistItems]);

  const handleRemove = async (productId) => {
    try {
      const updatedEntries = await removeFromWishlist(productId, user);
      setWishlist(buildWishlistItems(updatedEntries));
    } catch (error) {
      console.error("Error removing wishlist item:", error);
    }
  };



  return (
    <div className="page-content" style={{ minHeight: "100vh", paddingTop: "140px" }}>
      <div className="maxw">
        <h2 style={{ fontWeight: 600, marginBottom: "20px" }}>My Wishlist</h2>

        {loading ? (
          <div>Loading...</div>
        ) : wishlist.length === 0 ? (
          <div className="alert alert-info">Your wishlist is empty</div>
        ) : (
          <div className="row g-4">
            {wishlist.map((item) => (
              <div className="col-12 col-md-4 col-lg-3" key={item.productId}>
                <div className="card h-100">
                  <Link to={`/products/${slugify(item.name)}`} className="navlink">
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      className="card-img-top"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                  </Link>
                  <div className="card-body d-flex flex-column">
                    <Link to={`/products/${slugify(item.name)}`} className="navlink">
                      <h6 style={{ fontWeight: 600 }}>{item.name}</h6>
                    </Link>
                    <p className="text-muted mb-2">{item.category}</p>
                    <p style={{ fontWeight: 600, color: "#ff6344" }}>{item.category ==='Frames' ? 'From' : 'LE'} {item.price}.00 {item.category ==='Frames' ? 'LE' : ''}</p>
                    <button
                      className="btn btn-outline-success btn-sm mt-auto"
                      onClick={() => navigate(`/products/${slugify(item.name)}`)}
                    >
                      Add to Cart
                    </button>
                    <button
                      className="btn btn-outline-danger btn-sm  mt-2"
                      onClick={() => handleRemove(item.productId)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
